<div class="weekpicker-container" (document:click)="onDropdownEvent($event, pickerContainer)" #pickerContainer>
  <div class="date-selector">
    <object type="image/svg+xml" style="width: 16px; height: 16px; margin-right: 8px;"
      data="assets/images/shared/ic_calendar.svg">Your browser does not support SVGs</object>
    <span style="padding-right: 32px;">
      {{selectedFromDate | date:'d MMM yyyy'}} - {{selectedToDate | date:'d MMM yyyy'}}
    </span>
    <object type="image/svg+xml" style="width: 10px; height: 10px; margin-left: auto;" 
      data="assets/images/shared/ic_caret_down.svg">Your browser does not support SVGs</object>
  </div>
  <ul class="dropdown">
    <li class="list-item" *ngFor="let week of weekList" 
      (click)="onSelectWeek(week.fromDate, week.toDate)" 
      [class.selected]="week.fromDate.getTime() === selectedFromDate.getTime() ? true : false">
      
      {{week.fromDate | date:'d MMM yyyy'}} - {{week.toDate | date:'d MMM yyyy'}}
    </li>
  </ul>
</div>
